import { makeInflect } from "../../../../core/utils/makeInflect.js";

export const inflectNumber = makeInflect("číslo", "čísla", "čísel");
